/* <hp-bundle>: add-all bundle used by sections/handpicked-products.liquid and snippets/routine-pairs.liquid.
   Markup: data-function-url, data-discount, a <script type="application/json"> item list,
   a [data-bundle-add] button and a [data-bundle-error] element. */
/* Add-all bundle: same flow as products-bundle.js. The Supabase function returns one
   discounted bundle variant, which is added to the cart and opens the drawer. */
if (!customElements.get('hp-bundle')) {
  customElements.define('hp-bundle', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-bundle-add]');
      this.error = this.querySelector('[data-bundle-error]');
      this.button.addEventListener('click', () => this.add());
    }

    add() {
      const items = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.button.disabled = true;
      this.button.classList.add('btn--loading');
      this.error.textContent = '';

      fetch(this.dataset.functionUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          variant_ids: items.map((i) => i.variant_id),
          product_ids: items.map((i) => i.product_id),
          variant_titles: items.map((i) => i.title),
          discount_value: Number(this.dataset.discount),
          country_code: (window.Shopify && window.Shopify.country) || 'XX',
        }),
      })
        .then((r) => r.json().then((data) => {
          if (!r.ok || !data.bundle_variant_id) throw new Error(data.error || r.statusText);
          return data;
        }))
        .then((data) => {
          let sections = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
          );
          const drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.getSectionsToRender) sections = [...sections, ...drawer.getSectionsToRender().map((s) => s.id)];
          const mainCart = document.querySelector('cart-items');
          if (mainCart && mainCart.getSectionsToRender) sections = [...sections, ...mainCart.getSectionsToRender().map((s) => s.section)];

          return fetch(FoxThemeSettings.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({
              items: [{ id: data.bundle_variant_id, quantity: 1 }],
              sections,
              sections_url: window.location.pathname,
            }),
          }).then((r) => r.json());
        })
        .then((cart) => {
          if (cart.status) throw new Error(cart.description || cart.message);
          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, cart);
        })
        .catch((e) => {
          console.error('[hp-bundle]', e);
          this.error.textContent = e.message || 'Something went wrong. Please try again.';
        })
        .finally(() => {
          this.button.disabled = false;
          this.button.classList.remove('btn--loading');
        });
    }
  });
}
